import React, { ComponentProps, CSSProperties } from "react";
import { Spin } from "antd";

import styles from "./Spinner.module.less";

// Parent must have "position: relative" for the loading spinner container to be positioned correctly.

type SpinnerPropsT = ComponentProps<typeof Spin> & {
  loading?: boolean;
  noMask?: boolean;
  bgWhite?: boolean;
  containerStyles?: CSSProperties;
};

const Spinner = ({
  children = null,
  loading = false,
  size = "large",
  noMask = false,
  bgWhite = false,
  containerStyles = {},
  ...rest
}: SpinnerPropsT) => {
  return loading ? (
    <div
      className={[
        ...(noMask ? [styles.loadingSpinnerNoMask] : [styles.loadingSpinner]),
        ...(bgWhite ? [styles.bgWhite] : []),
      ].join(" ")}
      style={containerStyles}
      data-test-id="spinner"
    >
      <div className={styles.loadingContainer}>
        <Spin className={styles.spinner} size={size} {...rest}>
          {children}
        </Spin>
      </div>
    </div>
  ) : null;
};

export default Spinner;
